(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vinyl-artist-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nv-artist-filter')) {
    customElements.define('nv-artist-filter', class extends HTMLElement {
      connectedCallback() {
        const details = this.querySelector('details');
        const input = this.querySelector('input');
        const search = this.querySelector('.nv-artist__search');
        const status = this.querySelector('.nv-artist__status');
        const empty = this.querySelector('.nv-artist__empty');
        const items = Array.from(this.querySelectorAll('[data-artist-name]'));
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[’‘]/g, "'");
        search.hidden = false;
        input.addEventListener('input', () => {
          const query = normalize(input.value.trim());
          let count = 0;
          items.forEach(item => {
            item.hidden = !normalize(item.dataset.artistName).includes(query);
            if (!item.hidden) count++;
          });
          status.textContent = this.dataset.resultText.replace('[count]', count);
          status.hidden = false;
          empty.hidden = count !== 0;
        });
        this.addEventListener('click', event => {
          const link = event.target.closest('a');
          if (!link) return;
          const target = new URL(link.href);
          const params = new URLSearchParams(window.location.search);
          params.delete('page');
          params.delete('section_id');
          params.delete('sections');
          target.search = params.toString();
          link.href = target.href;
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !details.open) return;
          details.open = false;
          details.querySelector('summary').focus();
          event.stopPropagation();
        });
        this._outside = event => {
          if (!this.contains(event.target)) details.open = false;
        };
        document.addEventListener('click', this._outside);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this._outside);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
